import React from "react";
import RenderSteps from "./RenderSteps";

function AddCourse(props) {
  return (
    <div>
      <div>
        {/* Heading */}
        <div className="text-richblack-25">
          <p className="text-3xl">Add Course</p>
        </div>

        <div className="flex justify-between max-[450px]:flex-col gap-10 w-full mt-10">
          {/* Page component */}
          <div className="w-[70%] max-[450px]:w-[100%]">
            {/* form */}
            <RenderSteps />
          </div>

          {/* right side component code upload tips */}
          <div className="text-richblack-25 w-[45%] max-[450px]:w-[100%] h-full bg-richblack-700 px-10 flex flex-col py-5 rounded-md">
            <p className="text-xl text-left">⚡ Course Upload Tips</p>
            <ul className="text-richblack-50 list-disc flex flex-col gap-y-2 mt-5">
              <li>Set the course price option or make it free.</li>

              <li>Standard size for the course thumbnail is 1024x570.</li>

              <li>Video section controls the course overview video.</li>

              <li>Course builder is where you create and organize a course.</li>

              <li>
                Add topics in the course builder section to create lessons,
                quizzes and assignments.
              </li>

              <li>
                Information from the additional data section shows up on the
                course page.
              </li>

              <li>Make announcements to notify about important updates.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCourse;
